package com.essntl.features.client.ui.allclients

import com.essntl.features.client.domain.model.ClientModel

interface AllClientsEvent {
    data class LoadClients(
        val client: ClientModel? = null,
        val refresh: Boolean = false,
    ) : AllClientsEvent

    data class SearchClient(val query: String) : AllClientsEvent
}